module.exports = __webpack_public_path__ + "9946eafddfeae9a529eb73062521b8ef.fbx";